(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/trend-indicator/assets/javascripts/trend-indicator.js') >= 0) return;  svs.modules.push('/components/tipsen/trend-indicator/assets/javascripts/trend-indicator.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useState = _React.useState;
const TREND_RESET_TIMEOUT = 7 * 1000;
const blockName = 'pg_trend_indicator';
const Trends = {
  UP: 'up',
  DOWN: 'down'
};
const TrendIndicator = _ref => {
  let value = _ref.value,
    id = _ref.id,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? '' : _ref$suffix;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    trendClassName = _useState2[0],
    setTrendClassName = _useState2[1];
  const prevValueRef = useRef(value);
  const prevIdRef = useRef(id);
  const timeoutRef = useRef(null);
  useEffect(() => {
    if (prevIdRef.current !== id) {
      prevIdRef.current = id;
      prevValueRef.current = value;
      setTrendClassName('');
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      return;
    }
    if (value > prevValueRef.current) {
      setTrendClassName("".concat(blockName, "--").concat(Trends.UP));
    } else if (value < prevValueRef.current) {
      setTrendClassName("".concat(blockName, "--").concat(Trends.DOWN));
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setTrendClassName('');
    }, TREND_RESET_TIMEOUT);
    prevValueRef.current = value;
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [value, id]);
  return React.createElement("div", {
    className: "".concat(blockName, " ").concat(trendClassName).trim()
  }, value, suffix);
};
setGlobal('svs.components.tipsen.trendIndicator', {
  TrendIndicator
});

 })(window);